import type { ReactNode } from 'react';

export enum ICON_CONST {
  TEST_ID = 'icon-wrapper',
}

export type IconWrapperProps = HTMLAttributes<HTMLDivElement> & {
  color?: string;
  textAlign?: 'center' | 'left' | 'right';
  children: ReactNode;
};

export default IconWrapperProps;
